// RecentTab.tsx
import { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import RecentTask from "./RecentTasks";
import { activitySubTabsSx } from "./activityTabsSx";

const RecentTab = () => {
  const [tabIndex, setTabIndex] = useState(() => {
    const savedTabIndex = sessionStorage.getItem("recentTabIndex");
    return savedTabIndex ? Number(savedTabIndex) : 0;
  });

  useEffect(() => {
    sessionStorage.setItem("recentTabIndex", tabIndex.toString());
    // Reset current page when switching tabs
    sessionStorage.setItem("recentTasksCurrentPage", "1");
  }, [tabIndex]);

  const taskSource = tabIndex === 0 ? "ticket" : "email";

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(_, val) => setTabIndex(val)}
        sx={activitySubTabsSx}
      >
        <Tab label="Tickets" />
        <Tab label="Emails" />
      </Tabs>

      <div className="pt-3 px-3 pb-0">
        <RecentTask task_source={taskSource} />
      </div>
    </>
  );
};

export default RecentTab;